import { Plus } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type IAddMemberDialogProps = React.PropsWithChildren<{
  appName: string;
  trigger?: React.ReactNode;
}>;

const defaultTrigger = (
  <Button size="sm">
    <Plus /> Add members
  </Button>
);

const AddMemberDialog = ({ appName, trigger = defaultTrigger, children }: IAddMemberDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="w-230 sm:max-w-[calc(100vw-48px)] max-h-[min(640px,100dvh-48px)] grid-rows-[auto_1fr_auto] max-sm:h-dvh max-sm:w-full max-sm:max-h-none max-sm:max-w-none max-sm:rounded-none max-sm:border-0">
        <DialogHeader>
          <DialogTitle>Add members to {appName}</DialogTitle>
          <DialogDescription>
            Anyone you add here can see all of {appName}, including every protection in it. If a team member isn&apos;t
            listed, add them to your organization first.
          </DialogDescription>
        </DialogHeader>
        <div className="max-sm:min-h-0 max-sm:overflow-y-auto">{children}</div>
        <DialogFooter className="shrink-0">
          <DialogClose asChild>
            <Button>Done</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddMemberDialog;
